import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=2f7a07b8&scoped=true&"
import script from "./gift.vue?vue&type=script&lang=js&"
export * from "./gift.vue?vue&type=script&lang=js&"
import style0 from "./gift.vue?vue&type=style&index=0&id=2f7a07b8&lang=scss&scoped=true&"
import style1 from "./gift.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./gift.vue?vue&type=style&index=2&id=2f7a07b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a07b8",
  null
  
)

export default component.exports